import * as React from 'react';
import { styles } from './styles';
import { InputLabel } from '../InputLabel';
import { Input } from '../Input';

interface Props {
  children: React.ReactNode;
}

export class InputGroup extends React.Component<Props> {
  static Label = InputLabel;
  static Input = Input;
  render() {
    return (
      <div className={styles.container}>
        {/* {React.Children.map(this.props.children, child =>
          React.cloneElement(child as JSX.Element, {
            inGroup: true,
            isLast: true
          })
        )} */}
        {this.props.children}
      </div>
    );
  }
}
